import { Search, X } from 'lucide-react';
import { useRef } from 'react';
import { cx } from '../../components/ui';
import { useT } from '../../i18n';

/** Large search box with a clear button (no hover-only affordances). */
export function SearchField({
  value,
  onChange,
  placeholder,
  autoFocus,
  className,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  autoFocus?: boolean;
  className?: string;
}) {
  const t = useT();
  const ref = useRef<HTMLInputElement>(null);
  return (
    <div className={cx('relative', className)}>
      <Search className="pointer-events-none absolute top-1/2 left-4 size-5 -translate-y-1/2 text-[var(--muted)]" aria-hidden />
      <input
        ref={ref}
        type="search"
        inputMode="search"
        enterKeyHint="search"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        autoFocus={autoFocus}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="min-h-12 w-full rounded-2xl border border-[var(--line)] bg-[var(--surface)] py-3 pr-14 pl-12 text-[17px] text-[var(--ink)] placeholder:text-[var(--muted)] focus:border-[var(--focus)] focus:ring-2 focus:ring-[var(--focus)]/30 focus:outline-none [&::-webkit-search-cancel-button]:hidden"
      />
      {value ? (
        <button
          type="button"
          onClick={() => {
            onChange('');
            ref.current?.focus();
          }}
          aria-label={t('library.search_clear')}
          title={t('library.search_clear')}
          className="absolute top-1/2 right-1 inline-flex size-11 -translate-y-1/2 items-center justify-center rounded-xl text-[var(--muted)] hover:bg-[var(--accent-soft)]"
        >
          <X className="size-5" aria-hidden />
        </button>
      ) : null}
    </div>
  );
}
